export default __webpack_public_path__ + "static/media/img_15.7f1c243f.JPG";